/* eslint-disable prettier/prettier */
/* eslint-disable react/style-prop-object */
/* eslint-disable prettier/prettier */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from '../../styles/layout/MobileBottomNav.module.css';
import { useAuth } from '../../hooks/useAuth';
import LogoutConfirmModal from '../controlVariations/LogoutConfirmModal';
import iconlogout from '../../assets/images/icon/iconlogout.png';

// 💡 Import all your icons
// import { ReactComponent as DashboardIcon } from '../assets/icons/dashboard.svg';
import { ReactComponent as CoursesIcon } from '../../assets/icons/courses.svg';
import { ReactComponent as ScheduleIcon } from '../../assets/icons/schedule.svg';
import { ReactComponent as NotesIcon } from '../../assets/icons/notes.svg';
import { ReactComponent as AnalyticsIcon } from '../../assets/icons/analytics.svg';
import { ReactComponent as HelpIcon } from '../../assets/icons/helpSupport.svg';
import { ReactComponent as SettingsIcon } from '../../assets/icons/settings.svg';
import { ReactComponent as MessagesIcon } from '../../assets/icons/message.svg';
import { ReactComponent as ProfileIcon } from '../../assets/icons/MobileProfileIcon.svg';
// import { ReactComponent as ProgramsIcon } from '../assets/icons/ProgramsIcon.svg';
import { useUserProfile } from '../../hooks/useUserProfile';

// Reusing existing SVGs or simple placeholders

const SearchIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
		fill="none"
	>
		<path
			d="M20.75 20.75L15.9278 15.9278M18.5278 9.63889C18.5278 14.5481 14.5481 18.5278 9.63889 18.5278C4.72969 18.5278 0.75 14.5481 0.75 9.63889C0.75 4.72969 4.72969 0.75 9.63889 0.75C14.5481 0.75 18.5278 4.72969 18.5278 9.63889Z"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

// const ProfileIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="35" height="38" viewBox="0 0 35 38" fill="none">
//   <mask id="mask0_19371_2458" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="5" y="5" width="25" height="25">
//     <circle cx="17.5" cy="17.5" r="12.5" fill="white"/>
//   </mask>
//   <g mask="url(#mask0_19371_2458)">
//     <path d="M17.5 2.5C25.7843 2.5 32.5 9.21573 32.5 17.5C32.5 25.7843 25.7843 32.5 17.5 32.5C9.21573 32.5 2.5 25.7843 2.5 17.5C2.5 9.21573 9.21573 2.5 17.5 2.5Z" fill="#D9D9D9" stroke="white" stroke-width="5"/>
//     <rect x="9.04297" y="21.7063" width="16.9128" height="15.4645" rx="7.73223" fill="white"/>
//     <rect x="13.3203" y="10.4434" width="8.35836" height="9.38637" rx="4.17918" fill="white"/>
//   </g>
// </svg>
// );

const ProgramsIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="20"
		viewBox="0 0 22 20"
		fill="none"
	>
		<path
			d="M10.75 4.75V18.75M10.75 4.75C10.75 3.68913 10.3286 2.67172 9.57843 1.92157C8.82828 1.17143 7.81087 0.75 6.75 0.75H1.75C1.48478 0.75 1.23043 0.855357 1.04289 1.04289C0.855357 1.23043 0.75 1.48478 0.75 1.75V14.75C0.75 15.0152 0.855357 15.2696 1.04289 15.4571C1.23043 15.6446 1.48478 15.75 1.75 15.75H7.75C8.54565 15.75 9.30871 16.0661 9.87132 16.6287C10.4339 17.1913 10.75 17.9544 10.75 18.75M10.75 4.75C10.75 3.68913 11.1714 2.67172 11.9216 1.92157C12.6717 1.17143 13.6891 0.75 14.75 0.75H19.75C20.0152 0.75 20.2696 0.855357 20.4571 1.04289C20.6446 1.23043 20.75 1.48478 20.75 1.75V14.75C20.75 15.0152 20.6446 15.2696 20.4571 15.4571C20.2696 15.6446 20.0152 15.75 19.75 15.75H13.75C12.9544 15.75 12.1913 16.0661 11.6287 16.6287C11.0661 17.1913 10.75 17.9544 10.75 18.75"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

const DashboardIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="24"
		viewBox="0 0 22 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.875 22.2503V16.6253C7.875 14.8991 9.27375 13.5003 11 13.5003V13.5003C12.7263 13.5003 14.125 14.8991 14.125 16.6253V22.2503H21V11.5178C21 10.8553 20.7363 10.2191 20.2675 9.75031L11.8837 1.36656C11.395 0.877812 10.6038 0.877812 10.1163 1.36656L1.7325 9.75031C1.26375 10.2191 1 10.8553 1 11.5178V22.2503H7.875Z"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

const MobileBottomNav: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [showProfileMenu, setShowProfileMenu] = React.useState(false);
	const [showLogoutConfirm, setShowLogoutConfirm] = React.useState(false);

	const { logout } = useAuth();

	const { profile } = useUserProfile();

	const basePath = React.useMemo(() => {
		if (profile?.rolename === 'guest') return '/dashboard';
		else if (profile?.rolename === 'coach') return '/dashboard';
		else if (profile?.rolename === 'coachee')
			return '/dashboard'; // default coachee
		else return '/dashboard'; // fallback
	}, [profile?.rolename]);

	const isGuest = profile?.rolename === 'guest';

	const navItems = [
		{
			id: 'dashboard',
			label: 'Home',
			icon: <DashboardIcon />,
			path: basePath,
			disabled: false, // always enabled
		},
		{
			id: 'programs',
			label: 'Programs',
			icon: <ProgramsIcon />,
			path: `${basePath}/programs`,
			disabled: isGuest, // 🚫 guest blocked
		},
		{
			id: 'search',
			label: 'Search',
			icon: <SearchIcon />,
			path: '',
			disabled: true, // 🚫 always disabled
		},
		{
			id: 'profile',
			label: 'Profile',
			icon: <ProfileIcon />,
			path: `${basePath}/profile`,
			disabled: isGuest, // 🚫 guest blocked
		},
	];

	// Helper to check active state
	const isActive = (item: { path: string; disabled?: boolean }) => {
		if (!item.path || item.disabled) return false;
		return location.pathname === item.path;
	};

	return (
		<>
			{/* Bottom Navigation */}
			<div className={styles.bottomNav}>
				{navItems.map(item => {
					const active = isActive(item);

					return (
						<div
							key={item.id}
							className={`${styles.navItem} ${active ? styles.active : ''} ${item.disabled ? styles.disabled : ''}`}
							// onClick={() => {
							//     if (item.id === 'profile') {
							//         setShowProfileMenu(true);
							//         return;
							//     }

							//     if (item.disabled) return;
							//     navigate(item.path);
							// }}
							onClick={() => {
								if (item.disabled) return;

								navigate(item.path);
							}}
						>
							<div className={styles.iconWrapper}>
								{item.icon}
							</div>
							<span className={styles.label}>{item.label}</span>
						</div>
					);
				})}
			</div>

			{/* GREY BACKDROP */}
			{showProfileMenu && (
				<div
					className={styles.backdrop}
					onClick={() => setShowProfileMenu(false)}
				/>
			)}

			{/* LOGOUT BOTTOM SHEET */}
			{showProfileMenu && (
				<div className={styles.logoutSheet}>
					<button
						className={styles.logoutButton}
						onClick={() => {
							setShowProfileMenu(false);
							setShowLogoutConfirm(true);
						}}
					>
						<img
							src={iconlogout}
							alt="error"
							className={styles.logoutimg}
						/>

						<span className={styles.logoutlable}>Logout</span>
					</button>
				</div>
			)}

			{/* CONFIRM MODAL */}
			{showLogoutConfirm && (
				<LogoutConfirmModal
					open={showLogoutConfirm}
					onConfirm={async () => {
						await logout();
						navigate('/login', { replace: true });
					}}
					onCancel={() => setShowLogoutConfirm(false)}
				/>
			)}
		</>
	);
};

export default MobileBottomNav;
